import { Badge, ListItemButton, ListItemIcon, styled } from '@mui/material';

export const StyledNavBarWrap = styled(ListItemButton, {
	shouldForwardProp: (prop) => prop !== 'isSelected',
})<{ isSelected?: boolean }>(({ isSelected, theme }) => ({
	...(isSelected && {
		background: '#FFFFFF4D',
		boxShadow: '0px 0px 30px 0px #827D8326',
		gap: '8px',
		color: theme.palette.primary.main,
		'& .MuiListItemIcon-root': {
			background: '#FFFFFF80',
			boxShadow: '0px 0px 30px 0px #827D8326',
		},
	}),
}));

export const StyledNavBarIcon = styled(ListItemIcon)({});

export const StyledNavBarBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		minWidth: '8px',
		minHeight: '8px',
		padding: '0px',
		height: 'auto',
		background: theme.palette.error.contrastText,
		color: theme.palette.error.main,
	},
	'& .MuiListItemText-root': {
		margin: 0,
	},
}));
